import { NavLink } from 'react-router-dom';
import { Home, UtensilsCrossed, ShoppingBag, ClipboardList, User } from 'lucide-react';
import { useCart } from '@/context/CartContext';

const links = [
  { to: '/', icon: Home, label: 'Inicio' },
  { to: '/menu', icon: UtensilsCrossed, label: 'Menú' },
  { to: '/carrito', icon: ShoppingBag, label: 'Carrito' },
  { to: '/mis-pedidos', icon: ClipboardList, label: 'Pedidos' },
  { to: '/perfil', icon: User, label: 'Perfil' },
];

export default function BottomNav() {
  const { itemCount } = useCart();

  return (
    <nav data-testid="bottom-nav" className="fixed bottom-0 left-0 right-0 h-16 bg-black/90 backdrop-blur-xl border-t border-zinc-800/60 flex justify-around items-center z-50 safe-area-bottom">
      {links.map(({ to, icon: Icon, label }) => (
        <NavLink
          key={to}
          to={to}
          data-testid={`nav-${label.toLowerCase()}`}
          className={({ isActive }) =>
            `flex flex-col items-center gap-0.5 px-3 py-1 transition-colors relative ${isActive ? 'text-[#E84C1C]' : 'text-zinc-500 hover:text-zinc-300'}`
          }
        >
          <span className="relative">
            <Icon size={22} strokeWidth={1.8} />
            {label === 'Carrito' && itemCount > 0 && (
              <span className="absolute -top-2 -right-2.5 bg-[#E84C1C] text-white text-[10px] font-bold rounded-full min-w-[18px] h-[18px] flex items-center justify-center px-1">
                {itemCount}
              </span>
            )}
          </span>
          <span className="text-[10px] font-medium">{label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
